export  const webServices = {
    'facebook' : 'facebook',
    'twitter' :'twitter',
    'linkedin':'linkedin',
    'instagram' : 'instagram'
}